export const model = {
  id: null,
  name: '',
  graphic_type_id: null,
    total_working_day: null,
  break_end_time:'',
  created_at: '',
  updated_at: ''  
};
